import type { ButtonHTMLAttributes } from "react";
import { cx } from "./cx";

export type ButtonVariant = "primary" | "orange" | "ghost" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  /** Renders the POC's compact `.mini` button instead of the full `.btn`. */
  mini?: boolean;
}

export function Button({ variant, mini = false, className, type = "button", ...rest }: ButtonProps) {
  return <button type={type} className={cx(mini ? "mini" : "btn", variant, className)} {...rest} />;
}
